import type { LpTaskResponseContent } from "@vega-api/generated/types/lpTaskResponseContent";

export type WelcomeInfoTile = {
  icon?: string;
  title: string;
  subtitle: string;
};

export type WelcomeContent = {
  heading?: string;
  subheading?: string;
  description?: string;
  infoTiles?: WelcomeInfoTile[];
};

export type DocumentAcceptanceContent = {
  intro?: string;
  instructions?: string;
};

export type ConfirmationContentBox = {
  id: string;
  heading: string;
  body: string;
};

export type ConfirmationContent = {
  heading?: string;
  description?: string;
  confirmLabel?: string;
  declineLabel?: string;
  boxes?: ConfirmationContentBox[];
};

export type SurveyQuestionType = "FREE_TEXT" | "RATING";

export type SurveyQuestion = {
  id: string;
  type: SurveyQuestionType;
  label: string;
  // Scale endpoint labels for RATING questions, supplied by the backend.
  // May be absent/null for surveys configured before these fields existed.
  minLabel?: string | null;
  maxLabel?: string | null;
  placeholderText?: string | null;
};

export type SurveyContent = {
  questions?: SurveyQuestion[];
};

export type AnnouncementContent = {
  badge?: string;
  badgeIconName?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryActionRoute?: string;
};

export const readWelcomeContent = (
  content: LpTaskResponseContent,
): WelcomeContent => content as WelcomeContent;

export const readDocumentAcceptanceContent = (
  content: LpTaskResponseContent,
): DocumentAcceptanceContent => content as DocumentAcceptanceContent;

export const readConfirmationContent = (
  content: LpTaskResponseContent,
): ConfirmationContent => content as ConfirmationContent;

export const readSurveyContent = (
  content: LpTaskResponseContent,
): SurveyContent => content as SurveyContent;

export const readAnnouncementContent = (
  content: LpTaskResponseContent,
): AnnouncementContent => content as AnnouncementContent;
